import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./components/context/AuthContext";
import { MapContextProvider } from "./components/context/MapContext";
import { ThemeContextProvider } from "./components/context/ThemeContext";

ReactDOM.render(
  <React.StrictMode>
    <ThemeContextProvider>
      <AuthContextProvider>
        <MapContextProvider>
          <BrowserRouter basename={process.env.REACT_APP_BASEPATH}>
            <App />
          </BrowserRouter>
        </MapContextProvider>
      </AuthContextProvider>
    </ThemeContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
